import {
  FormLabel,
  Grid,
  Stack,
  Typography,
  FormControl,
  OutlinedInput,
  FormHelperText,
  Button,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logoIcon from "../../assets/images/logoIcon.svg";
import Alert from "../../components/dialog/Alert";
import NormalInput from "../../components/inputs/normalInput";
import NumberInput from "../../components/inputs/normalInput/number";
import Toaster from "../../components/toaster/toaster";
import Schema from "../../schema";
import { ROUTES } from "../../utils/routes";
import { companySignup, checkCompanyEmail } from "./action";

const CompanySignup = () => {
  const [step, setStep] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const initialValues = {
    companyName: "",
    phoneNumber: "",
    contactPersonName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneCountryCode: "+91",
  };

  const nextStep = async (validateForm, setTouched, email) => {
    setTouched({ email: true });
    const errors = await validateForm();
    // Step 1 only blocks on the email field; other fields are filled in step 2.
    if (errors.email) {
      return;
    }
    const ok = await dispatch(checkCompanyEmail(email));
    if (ok) {
      setStep(2);
    }
  };

  const prevStep = () => setStep(1);

const clientLogos = [
  "https://www.inflyx.co/images/clients/Avaan.png",
  "https://www.inflyx.co/images/clients/Plush.png",
  "https://www.inflyx.co/images/clients/Pubjab_Govt.png",
  "https://www.inflyx.co/images/clients/Vim.png",
  "https://www.inflyx.co/images/clients/acko.png",
  "https://www.inflyx.co/images/clients/ageas.png",
  "https://www.inflyx.co/images/clients/bajaj-finserv.png",
  "https://www.inflyx.co/images/clients/barbeque.svg",
  "https://www.inflyx.co/images/clients/basic.svg",
  "https://www.inflyx.co/images/clients/blur.png",
  "https://www.inflyx.co/images/clients/cars24.png",
  "https://www.inflyx.co/images/clients/country-delight.svg",
  "https://www.inflyx.co/images/clients/dotkey.svg",
  "https://www.inflyx.co/images/clients/gcc.svg",
  "https://www.inflyx.co/images/clients/ghar_soap.png",
  "https://www.inflyx.co/images/clients/indrive.svg",
  "https://www.inflyx.co/images/clients/mars.png",
  "https://www.inflyx.co/images/clients/max_protein.svg",
  "https://www.inflyx.co/images/clients/nutrovally.svg",
  "https://www.inflyx.co/images/clients/plix.png",
  "https://www.inflyx.co/images/clients/quillbot.png",
  "https://www.inflyx.co/images/clients/raw.svg",
  "https://www.inflyx.co/images/clients/rosa_herbalcare.png",
  "https://www.inflyx.co/images/clients/shark.svg",
  "https://www.inflyx.co/images/clients/smart_bazar.png",
  "https://www.inflyx.co/images/clients/soulflower.svg",
  "https://www.inflyx.co/images/clients/sujata.png",
  "https://www.inflyx.co/images/clients/surf_excel.png",
  "https://www.inflyx.co/images/clients/suroskin.svg",
  "https://www.inflyx.co/images/clients/tinder.png", 
  "https://www.inflyx.co/images/clients/virgo.png"
    
  ];


  return (
    <>
      <div className="page-container">
        <div className="login-wrapper">
          {/* LEFT SIDE */}

          <div className="login-left">
            <img className="logo" src={logoIcon} alt="Inflyx Logo" />

            <h2>Get started for free</h2>
            <p className="sub">Join Inflyx and start your journey</p>
            <Toaster />
            <div className="stepper">
              <div className="step">
                <div className="circle">1</div>
                <div className="stitle">Business Email</div>
                <div className="sdesc">Enter your business email</div>
              </div>

              <div className="progress">
                <div
                  className="progress-fill"
                  style={{ width: step === 2 ? "100%" : "50%" }}
                />
              </div>

              <div className="step">
                <div className={`circle ${step === 1 ? "gray" : ""}`}>2</div>
                <div className="stitle">Account Details</div>
                <div className="sdesc">Fill in your information</div>
              </div>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={Schema.CompanySignup}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                // delete values.confirmPassword;
                dispatch(companySignup(values, navigate));
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
                setFieldValue,
                isValid,
                setFieldError,
                validateForm,
                setTouched,
                dirty,
              }) => (
                <Form>
                  {/* STEP 1 */}
                  {step === 1 && (
                    <div>
                      {/*  <Typography variant="h6" mb={2}>
                        Get Started
                      </Typography>

                      <Typography mb={2}>
                        Enter your business email to continue
                      </Typography> */}

                      <FormControl fullWidth margin="normal">
                        <FormLabel required focused={false}>
                          Business Email
                        </FormLabel>

                        <NormalInput
                          name={"email"}
                          type={"text"}
                          focused={false}
                          label={""}
                          sizeval="medium"
                          values={values.email}
                          placeholder="name@company.com"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(touched.email) && errors.email}
                          helperText={touched.email && errors.email}
                        />
                      </FormControl>

                      <Button
                        variant="contained login-btn"
                        onClick={() => nextStep(validateForm, setTouched, values.email)}
                        sx={{ mt: 2 }}
                      >
                        Continue
                      </Button>
                    </div>
                  )}

                  {/* STEP 2 */}
                  {step === 2 && (
                    <div>
                      <Typography variant="h6" mb={2}>
                        Account Details
                      </Typography>

                      <Stack spacing={2}>
                        <FormControl fullWidth>
                          <FormLabel required focused={false}>
                            Username
                          </FormLabel>
                          <NormalInput
                            name={"contactPersonName"}
                            type={"text"}
                            focused={false}
                            label={""}
                            sizeval="medium"
                            values={values.contactPersonName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              Boolean(touched.contactPersonName) &&
                              errors.contactPersonName
                            }
                            helperText={
                              touched.contactPersonName &&
                              errors.contactPersonName
                            }
                          />
                        </FormControl>

                        <FormControl fullWidth>
                          <FormLabel required focused={false}>
                            Company Name
                          </FormLabel>
                          <NormalInput
                            name={"companyName"}
                            type={"text"}
                            focused={false}
                            label={""}
                            sizeval="medium"
                            values={values.companyName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              Boolean(touched.companyName) && errors.companyName
                            }
                            helperText={
                              touched.companyName && errors.companyName
                            }
                          />
                        </FormControl>

                        <FormControl fullWidth>
                          <FormLabel required focused={false}>
                            Phone Number
                          </FormLabel>
                          <NumberInput
                            name={"phoneNumber"}
                            type={"number"}
                            focused={false}
                            label={""}
                            sizeval="medium"
                            values={values.phoneNumber}
                            onChange={(e) => {
                              if (e.target.value.length <= 10) {
                                handleChange(e);
                              } else {
                                e.preventDefault();
                              }
                            }}
                            onBlur={handleBlur}
                            error={
                              Boolean(touched.phoneNumber) && errors.phoneNumber
                            }
                            helperText={
                              touched.phoneNumber && errors.phoneNumber
                            }
                          />
                        </FormControl>

                        <FormControl fullWidth>
                          <FormLabel required focused={false}>
                            Password
                          </FormLabel>
                          <NormalInput
                            name={"password"}
                            type={showPassword ? "text" : "password"}
                            focused={false}
                            label={""}
                            sizeval="medium"
                            values={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.password) && errors.password}
                            helperText={touched.password && errors.password}
                            handleViewPassword={() =>
                              setShowPassword((prev) => !prev)
                            }
                            isEndAdornment={true}
                            showPassword={showPassword}
                          />
                        </FormControl>

                        <FormControl fullWidth>
                          <FormLabel required focused={false}>
                            Confirm Password
                          </FormLabel>
                          <NormalInput
                            name={"confirmPassword"}
                            type={showConfirmPassword ? "text" : "password"}
                            focused={false}
                            label={""}
                            sizeval="medium"
                            values={values.confirmPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              Boolean(touched.confirmPassword) &&
                              errors.confirmPassword
                            }
                            helperText={
                              touched.confirmPassword && errors.confirmPassword
                            }
                            isEndAdornment={true}
                            handleViewPassword={() =>
                              setShowConfirmPassword((prev) => !prev)
                            }
                            showPassword={showConfirmPassword}
                          />
                        </FormControl>
                      </Stack>

                      {/* BUTTONS */}
                      <Stack direction="row" spacing={2} mt={3}>
                        <Button
                          sx={{ flex: 1 }}
                          variant="outlined btn-back"
                          onClick={prevStep}
                        >
                          Back
                        </Button>

                        <Button
                          sx={{ flex: 1 }}
                          variant="contained login-btn"
                          type="submit"
                        >
                          Create Account
                        </Button>
                      </Stack>
                    </div>
                  )}
                </Form>
              )}
            </Formik>

            <div className="secure">
              🔒 Your information is secure and protected | No credit card
              required
            </div>

            <div className="hr"></div>

            <div className="login">
              Already have an account?{" "}
              <b>
                {" "}
                <Link to={ROUTES.LOGIN} className="text-decoration-none">Login</Link>
              </b>
            </div>
            <p className="policyLink d-flex align-item-center justify-content-center mt-4 fs14">
              <Link
                to={`/`}
                onClick={(e) => {
                  e.preventDefault();
                  window.open("/privacy-and-policy", "_blank");
                }}
                className=""
              >
                Privacy Policy
              </Link>
              <Link
                to={`/`}
                onClick={(e) => {
                  e.preventDefault();
                  window.open("/terms-and-conditions", "_blank");
                }}
                className=""
              >
                Terms and Condition
              </Link>
            </p>
          </div>

          {/* RIGHT SIDE */}
          <div className="login-right">
            <div className="badge">✨ Creator Discovery Platform</div>

            <div className="heading">
              Find the Perfect <span>Influencers</span>
              <br />
              For Every Campaign
            </div>

            <div className="description">
              Discover creators, analyze historical performance, evaluate
              audience quality, and measure campaign ROI with AI-powered
              insights built for modern brands.
            </div>

            <div className="features">
              <div className="feature">
                <div className="feature-icon">🧠</div>

                <div className="feature-text">
                  <h4>AI Matchmaking</h4>
                  <p>Find creators aligned with your campaign goals.</p>
                </div>
              </div>

              <div className="feature">
                <div className="feature-icon">📈</div>

                <div className="feature-text">
                  <h4>Historical Insights</h4>
                  <p>Analyze previous campaign performance.</p>
                </div>
              </div>

              <div className="feature">
                <div className="feature-icon">🎯</div>

                <div className="feature-text">
                  <h4>Campaign Analytics</h4>
                  <p>Track engagement, reach and ROI metrics.</p>
                </div>
              </div>
            </div>

            <div className="clients-section">
              <div className="clients-title">Trusted By Leading Brands</div>

              <div className="logo-slider">
                <div className="logo-track">
                  {[...clientLogos, ...clientLogos].map((logo, index) => (
                    <img key={index} src={logo} alt={`Client ${index}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Alert />
      <style>{`
      



.login-wrapper{
    width:auto;
    max-width:100%;
    background:rgba(255,255,255,0.05);
    backdrop-filter:blur(18px);
    -webkit-backdrop-filter:blur(18px);

  
    overflow:hidden;
    display:grid;
    grid-template-columns:0.85fr 1fr;
    position:relative;
    z-index:2;
}

/* =========================
   LEFT SIDE
========================= */

.login-left{
    background:#fff;
    padding:60px;
}

 .stepper {
            display: flex;
            align-items: flex-start;
            margin-bottom: 40px
        }

        .step {
            text-align: center;
            width: 140px
        }

        .circle {
            width: 58px;
            height: 58px;
            border-radius: 50%;
            margin: auto;
            background: linear-gradient(135deg, #4f5dff, #ff3ea5);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 28px;
            font-weight: 700;
            position: relative
        }

        .circle:before {
            content: '';
            position: absolute;
            inset: -6px;
            border: 3px solid transparent;
            border-top-color: #4f5dff;
            border-right-color: #ff3ea5;
            border-radius: 50%
        }

        .circle.gray {
            background: #f1f3f8;
            color: #222
        }

        .circle.gray:before {
            display: none
        }

        .progress {
            flex: 1;
            height: 4px;
            background: #e8e8ef;
            border-radius: 10px;
            margin-top: 28px;
            position: relative
        }

        .progress-fill {
            height: 100%;
            width: 50%;
            background: linear-gradient(90deg, #6b46ff, #ff3ea5);
            border-radius: 10px
        }

      

        .stitle {
            font-size: 14px;
            font-weight: 600;
            margin-top: 12px
        }

        .sdesc {
            font-size: 12px;
            color: #7a8198
        }

.logo{
    width:90px;
    margin-bottom:20px;
}

.small-title{
    color:#7c7c7c;
    font-size:15px;
    margin-bottom:10px;
}

.login-title{
    font-size:38px;
    font-weight:700;
    margin-bottom:40px;
}

.login-title span{
    background:linear-gradient(90deg,#6b6cff,#e445a3);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
}

.form-group{
    margin-bottom:22px;
}

.form-group label{
    display:block;
    margin-bottom:8px;
    font-weight:500;
}

.form-control{
    width:100%;
    height:56px;
    border:none;
    border-radius:12px;
    background:#f5f7fb;
    padding:0 18px;
    font-size:15px;
}

.form-control:focus{
    outline:none;
    border:2px solid #6b6cff;
}

.row{
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:10px;
    margin:20px 0;
}

.btn-back{

 width:100%;
    height:50px;
    border:1px solid;
    border-radius:12px;
    cursor:pointer;
    color:#000;
    font-size:18px;
    font-weight:600;
   /*  background:linear-gradient(90deg,#5b6dff,#e83c9d); */
}

.login-btn{
    width:100%;
    height:50px;
    border:none;
    border-radius:12px;
    cursor:pointer;
    color:#fff;
    font-size:18px;
    font-weight:600;
    background:linear-gradient(90deg,#5b6dff,#e83c9d);
}

.signup{
    text-align:center;
    margin-top:25px;
}
  .secure {
            text-align: center;
            color: #7a8198;
            margin: 16px 0
        }

         .hr {
            height: 1px;
            background: #ececf3;
            margin: 20px 0
        }

 .login {
            text-align: center;
            color: #7a8198
        }

/* =========================
   RIGHT SIDE
========================= */

.login-right{
    padding:70px;
    color:#fff;
    display:flex;
    flex-direction:column;
    justify-content:center;
    overflow:hidden;
    background: linear-gradient(90deg, #5b6dff, #e83c9d);
}

.badge{
    width:max-content;
    padding:10px 18px;
    border-radius:50px;
    background:rgba(255,255,255,.1);
    margin-bottom:30px;
}

.heading{
    font-size:48px;
    font-weight:700;
    line-height:1.2;
    margin-bottom:20px;
    opacity:0;
    transform:translateY(40px);
    animation:heroReveal 1.2s ease forwards;
}

.heading span{
    color:#ff69d6;
    position:relative;
}

.heading span::after{
    content:'';
    position:absolute;
    left:0;
    bottom:-4px;
    width:100%;
    height:4px;
    background:#ff69d6;
    transform:scaleX(0);
    transform-origin:left;
    animation:lineReveal 1s ease forwards 1s;
}

@keyframes heroReveal{
    to{
        opacity:1;
        transform:translateY(0);
    }
}

@keyframes lineReveal{
    to{
        transform:scaleX(1);
    }
}
.description{
    font-size:17px;
    color:#d6d6d6;
    line-height:1.8;
    margin-bottom:40px;
}

.features{
    display:flex;
    flex-direction:column;
    gap:22px;
}

.feature{
    display:flex;
    align-items:center;
    gap:15px;
}

.feature-icon{
    width:52px;
    height:52px;
    border-radius:12px;
    background:rgba(255,255,255,.12);
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:24px;
}

.feature-text h4{
    font-size:20px;
    margin-bottom:4px;
}

.feature-text p{
    color:#d8d8d8;
    font-size:14px;
}

.stats{
    margin-top:50px;
    display:flex;
    gap:40px;
}

.stat h2{
    font-size:34px;
}

.stat p{
    color:#cfcfcf;
    font-size:14px;
}

/* =========================
   CLIENT LOGO SLIDER
========================= */

.clients-section{
    margin:35px 0;
}

.clients-title{
    font-size:13px;
    color:rgba(255,255,255,.7);
    text-transform:uppercase;
    letter-spacing:2px;
    margin-bottom:15px;
}

.logo-slider{
    width:100%;
    overflow:hidden;
    position:relative;
}

.logo-track{
    display:flex;
    align-items:center;
    gap:50px;
    width:max-content;
    animation:scroll 120s linear infinite;
    will-change:transform;
}

.logo-track img{
    height:40px;
    width:auto;
    max-width:140px;
    object-fit:contain;
    opacity:.9;
    transition:.3s ease;
}

.logo-track img:hover{
    opacity:1;
    transform:scale(1.25);
}

.logo-slider::before,
.logo-slider::after{
    content:'';
    position:absolute;
    top:0;
  
    z-index:2;
}

.logo-slider::before{
    left:0;
    background:linear-gradient(to right,#070314,transparent);
}

.logo-slider::after{
    right:0;
    background:linear-gradient(to left,#070314,transparent);
}

@keyframes scroll{
    from{
        transform:translateX(0);
    }
    to{
        transform:translateX(-50%);
    }
}

/* =========================
   TABLET
========================= */

@media (max-width:991px){

    .login-wrapper{
        grid-template-columns:1fr;
        max-width:700px;
    }

    .login-right{
        order:-1;
        padding:40px;
    }

    .login-left{
        padding:40px;
    }

    .heading{
        font-size:34px;
    }

    .description{
        font-size:15px;
    }

    .stats{
        flex-wrap:wrap;
        gap:25px;
    }

    .logo-track img{
        height:34px;
        max-width:120px;
    }
}

/* =========================
   MOBILE
========================= */

@media (max-width:768px){

    body{
        padding:15px;
    }

    body::before{
        width:350px;
        height:350px;
    }

    body::after{
        width:300px;
        height:300px;
    }

    .login-left,
    .login-right{
        padding:30px;
    }

    .login-title{
        font-size:30px;
    }

    .heading{
        font-size:28px;
        line-height:1.3;
    }

    .description{
        font-size:14px;
    }

    .feature-icon{
        width:46px;
        height:46px;
        font-size:20px;
        flex-shrink:0;
    }

    .feature-text h4{
        font-size:17px;
    }

    .feature-text p{
        font-size:13px;
    }

    .logo-track{
        gap:35px;
        animation:scroll 30s linear infinite;
    }

    .logo-track img{
        height:30px;
        max-width:100px;
    }
}

@media (max-width:576px){

    body{
        padding:10px;
    }

    .login-wrapper{
        border-radius:18px;
    }

    .login-left,
    .login-right{
        padding:24px;
    }

    .badge{
        font-size:12px;
        padding:8px 14px;
    }

    .login-title{
        font-size:26px;
        margin-bottom:25px;
    }

    .heading{
        font-size:24px;
    }

    .form-control{
        height:52px;
        font-size:14px;
    }

    .login-btn{
        height:52px;
        font-size:16px;
    }

    .row{
        flex-direction:column;
        align-items:flex-start;
    }

    .stats{
        flex-direction:column;
        gap:18px;
    }

    .stat h2{
        font-size:28px;
    }

    .logo-track{
        gap:25px;
        animation:scroll 25s linear infinite;
    }

    .logo-track img{
        height:26px;
        max-width:90px;
    }

    .clients-title{
        font-size:11px;
        letter-spacing:1px;
    }
}

@media (max-width:420px){

    .logo{
        width:70px;
    }

    .login-title{
        font-size:24px;
    }

    .heading{
        font-size:22px;
    }

    .feature-icon{
        width:42px;
        height:42px;
        font-size:18px;
    }

    .logo-track img{
        height:24px;
        max-width:80px;
    }
}
      
      
      `}</style>
    </>
  );
};

export default CompanySignup;
